import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { selectAttribute } from 'shared/selectors';
import { userRegister, userVerification, userVerificationResend } from './actions';
import RegistrationComponent from './view';

const REGISTRATION_REDUCER_KEY = 'registrationReducer';
const ATTR_REGISTRATION_KEY = 'registration';
const ATTR_VERIFICATION_KEY = 'verification';
const ATTR_VERIFICATION_RESEND_KEY = 'verificationResend';

const mapStateToProps = (state) => ({
  userRegistration: selectAttribute(REGISTRATION_REDUCER_KEY, ATTR_REGISTRATION_KEY)(state),
  userVerification: selectAttribute(REGISTRATION_REDUCER_KEY, ATTR_VERIFICATION_KEY)(state),
  userVerificationResend: selectAttribute(
    REGISTRATION_REDUCER_KEY,
    ATTR_VERIFICATION_RESEND_KEY
  )(state),
});

const mapDispatchToProps = (dispatch) => ({
  onRegistration: bindActionCreators(userRegister, dispatch),
  onVerification: bindActionCreators(userVerification, dispatch),
  onVerificationResend: bindActionCreators(userVerificationResend, dispatch),
});

const Registration = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RegistrationComponent)
);

export default Registration;
